import "./Contact.module.css";
import NexoNavigation from "@/reusable_sections/Header";
import TechnicalInquiry from "./sections/TechnicalInquiry";
import GlobalPresence from "./sections/GlobalPresence";
import GlobalFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <NexoNavigation />
      <TechnicalInquiry />
      <GlobalPresence />
      <GlobalFooter />
    </div>;
}